<label
  nz-checkbox
  [(ngModel)]="internalValue"
  [nzDisabled]="disabled"
  (blur)="syncExternalTouched()"
  (ngModelChange)="onModelChange($event)">
  <span
    *ngIf="!selectByCheckboxOnly"
    [innerHTML]="label | transloco"></span
></label>
